import "./buttonsStyle.css";

const CustomButton = ({
  label,
  clsNames = "",
  disabled,
  onClickFn = () => {},
  styles={}
}) => {
  return (
    <button
      disabled={disabled}
      className={clsNames}
      onClick={onClickFn}
      type="button"
      style={styles}
    >
      {label ? <span id="btn-lbl">{label}</span> : ""}
    </button>
  );
};

export default CustomButton;
